'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NotFound = undefined;

var _NotFound2 = require('./NotFound');

var _NotFound3 = _interopRequireDefault(_NotFound2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.NotFound = _NotFound3.default;


//////////////////
// WEBPACK FOOTER
// ./src/containers/NotFound/index.jsx
// module id = 1816
// module chunks = 0